import { colors } from '@everlywell/leaves';
import Layout from 'components/Layout';
import {
  FAQContainer as FAQSection,
  IFAQContainer,
} from 'containers/Patients/FAQContainer';
import { IInquiryContainer } from 'containers/Patients/InquiryContainer';
import {
  HeroContainer as HeroSection,
  ISolutionsHeroContainer,
} from 'containers/Solutions/Hero';
import { graphql } from 'gatsby';
import React, { LazyExoticComponent, lazy } from 'react';
import { IContentWithImage } from 'utils/types';

import { SEO } from '../components/SEO';
const InquirySection = lazy(
  () => import('containers/Patients/InquiryContainer'),
);

const components: {
  HeroSection: React.FunctionComponent<ISolutionsHeroContainer>;
  FAQSection: React.FunctionComponent<IFAQContainer>;
  InquirySection: LazyExoticComponent<React.FC<IInquiryContainer>>;
} = {
  HeroSection,
  FAQSection,
  InquirySection,
};

type Props = {
  data: {
    patientsContent: {
      title: string;
      heroSection: {
        headline: string;
        description?: {
          description: string;
        };
        backgroundColor?: string;
      };
      sections: {
        componentName: string;
        headline: string;
        description?: { description: string };
        slug: string;
        title?: string;
        listOfContentWithImages?: IContentWithImage[];
      }[];
    };
  };
};

export const Head = () => <SEO />;

export const patientsPage = (props: Props) => {
  const { data } = props;
  const { patientsContent } = data;
  const { heroSection, sections, title } = patientsContent;

  return (
    <Layout>
      <HeroSection
        content={heroSection}
        title={title}
        headlineStyle={{ color: colors.white }}
      />
      {sections.map((section, i: number) => {
        // @ts-ignore
        if (components[section.componentName]) {
          return React.createElement(
            // @ts-ignore
            components[section.componentName],
            {
              content: section,
              key: `${section.componentName}-${i}`, // handles the case for duplicate section keys
            },
          );
        }
      })}
    </Layout>
  );
};

export default patientsPage;

export const data = graphql`
  query {
    patientsContent: contentfulPage(pageId: { eq: "EHSForPatientsPage" }) {
      title
      heroSection {
        headline
        description {
          description
        }
        componentName
        backgroundColor
        cta {
          text
          url
        }
        desktopImage {
          title
          gatsbyImageData(
            placeholder: BLURRED
            layout: FULL_WIDTH
            quality: 75
            resizingBehavior: FILL
            cropFocus: FACE
          )
        }
      }
      sections {
        title
        headline
        componentName
        slug
        backgroundColor
        description {
          description
        }
        sectionImage {
          title
          gatsbyImageData(placeholder: BLURRED, quality: 75)
        }
        cta {
          text
          url
        }
        listOfContentWithImages {
          title
          heading
          backgroundColor
          description {
            description
            childMarkdownRemark {
              html
            }
          }
          slug
          cta {
            text
            url
          }
          image {
            title
            url
            gatsbyImageData(placeholder: BLURRED, quality: 75)
          }
        }
      }
    }
  }
`;
